import { useEffect, useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { LayerProps } from 'react-laag';

export function isInShadow(node?: Element | null): boolean {
    if (!node) {
        return false;
    }

    return node.getRootNode() instanceof ShadowRoot;
}

export function getFirstShadowElement(node?: Element | null): HTMLElement | undefined {
    if (!node || !isInShadow(node)) {
        return;
    }

    const shadowRoot = node?.getRootNode() as ShadowRoot;

    const firstElementChild = Array.from(shadowRoot.children).find((el) => el.tagName !== 'STYLE');

    return firstElementChild as HTMLElement;
}

export function useKeyDown(key: KeyboardEvent['key'], callback: (event: KeyboardEvent) => void) {
    useEffect(() => {
        function handler(event: KeyboardEvent) {
            if (event.key === key) {
                callback(event);
            }
        }

        window.addEventListener('keydown', handler);

        return () => {
            window.removeEventListener('keydown', handler);
        };
    }, [callback, key]);
}

export function fixLayerProps(layerProps: LayerProps) {
    if (process.env.NODE_ENV === 'test') {
        layerProps.style = {
            ...layerProps.style,
            top: Number.isInteger(layerProps.style.top) ? layerProps.style.top : 0,
            left: Number.isInteger(layerProps.style.left) ? layerProps.style.left : 0,
        };
    }
}

export function useId(prefix: string): string {
    return useMemo(() => prefix + '-' + uuidv4(), [prefix]);
}
